// extracted by mini-css-extract-plugin
export default {"root":"__bVYP8W"};